import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  url: `https://tax.waltio.com`,
  apiUrl: `https://data.waltio.com/live`,
  stripe: `pk_live_fXaIfiJtFZoLLcyQhW2dRDBl`,
  couchDbUrl: `couchdb/assessment-prod`,
  gtmId: `GTM-5J4MMHJ`,
  mixpanelToken: `f5943ac9e3f623c7b433ff1457e93c38`,
  auth0: {
    callback: `https://tax.waltio.com/callback`,
    clientID: `eXaIoqNRXwxNE6Td4OT3rh1XFp0RzsJ8`,
    domain: `auth.waltio.com`,
  },
  intercom: {
    secret: `RYggsG21Lm43TU0KCBCbN3RaiC4wQHgQLvBgHd-C`,
  },

  features: {
    pattern: `tax:prod:`,
  },
  facebookAppId: `4187836981451096`,
  mobile: {
    ios: `https://apps.apple.com/fr/app/waltio-crypto-portfolio-tax/id6737851296?+_branch_match_id=1448587401773288826`,
    android: `https://play.google.com/store/apps/details?id=com.waltio.m.twa`,
  },
};
